<template>
	<li>
		<a :href="url" class="link_thumb">
			<span class="box_thumb" v-if="thumbnail">
				<img :src="thumbnail" width="186" height="186" alt="" class="img_thumb" @error="onImgLoadingError" v-if="!isError">
				<span class="img_thumb album_regulate" v-else></span>
			</span>
		</a>

		<strong class="tit_gallery">
			<span class="ico_bbs ico_current" v-if="isCurrentArticle">현재 보고있는 페이지</span>
			<a :href="url" class="album_article_title" v-html="title" @click="onTitleClick"></a>
			<span class="ico_bbs ico_new" v-if="isNew">새글</span>
			<a href="javascript:" class="link_count" v-if="hasComment" @click="openCommentPopup">
				<span class="num_count_g">
					<span class="screen_out">댓글수</span>
					<span class="num_item" :class="commentCntClass">{{ shrtcmtcnt }}</span>
				</span>
			</a>
		</strong>

		<div class="opt_more_g txt_item writer_opt ">
			<a href="javascript:" class="txt_writer" @click="_openLayer">{{ nickname || '(익명)' }}</a>
		</div>

		<span class="txt_date">{{ regdtshow }}</span>
	</li>
</template>

<script>
import {openLayer} from '../../components/layer/event-bus.mjs';
import {mapState} from 'vuex';

export default {
	inheritAttrs: false,
	props: {
		grpid: {type: String},
		fldid: {type: String},
		dataid: {type: [String, Number]},
		thumbnail: {type: String, default: ''},
		dataname: {type: String},
		isNew: {type: Boolean},
		shrtcmtcnt: {type: Number, default: 0},
		isNewCmt: {type: Boolean},
		nickname: {type: String, default: ''},
		regdtshow: {type: String},
		bbsdepth: {type: String},

		userid: {type: String},
		encUserid: {type: String}
	},
	data() {
		return {
			isError: false
		};
	},
	computed: {
		...mapState({
			currentDataid: 'dataid',
			myUserId: 'userId',
			page: 'page',
			prevPage: 'prevPage',
			firstBbsDepth: 'firstBbsDepth',
			lastBbsDepth: 'lastBbsDepth',
			listNum: 'listNum',
			isAdmin: 'isAdmin',
			isBoardAdmin: 'isBoardAdmin',
			rolecode: 'rolecode',
			cafeRoles: 'cafeRoles'
		}),
		url() {
			return `/_c21_/album_read?grpid=${this.grpid}&fldid=${this.fldid}&contentval=${this.bbsdepth}&datanum=${this.dataid}
				&page=${this.page}&prev_page=${this.prevPage}&firstbbsdepth=${this.firstBbsDepth}&lastbbsdepth=${this.lastBbsDepth}&listnum=${this.listNum}`
		},
		isCurrentArticle() {
			return this.dataid.toString() === this.currentDataid;
		},
		title() {
			return this.dataname.replace(/<[^>]+>/g, '');
		},
		hasComment() {
			return this.shrtcmtcnt > 0;
		},
		commentCntClass() {
			return {
				new_comment: this.isNewCmt
			};
		},
		isMine() {
			return this.userid === this.myUserId;
		}
	},
	methods: {
		onImgLoadingError() {
			this.isError = true;
		},
		openCommentPopup(e) {
			window.viewShortComment(this.fldid, this.dataid);
			CafeTiara.trackEvent(e, '댓글보기(팝업창)', 'comment_view_btn', '일반게시판>게시글>');
		},
		_openLayer(e) {
			if (this.userid === '') {
				return;
			}

			openLayer(e, 'user', {
				grpid: this.grpid,
				isAdmin: this.isAdmin,
				rolecode: this.rolecode,
				encUserId: this.encUserid,
				isMine: this.isMine,
				author: this.nickname,
				cafeRoles: this.cafeRoles,
				canEditRolecode: this.isAdmin || this.isBoardAdmin
			});

			CafeTiara.trackEvent(e, '회원 닉네임 클릭', 'member_profile', '일반게시판>게시글>');
		},
		onTitleClick(e) {
			CafeTiara.trackEvent(e, '글뷰 하단 글목록 영역 클릭', 'article_title', '일반게시판>게시글>');
		}
	}
}
</script>
